import { styled as muiStyled, Stack, Typography } from '@mui/material';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

const Label = muiStyled(Typography)(() => ({
  fontStyle: 'normal',
  fontWeight: 600,
  color: NEW_COLORS.PRIMARY[400],
}));

const StackRow = muiStyled(Stack)(() => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

const StackCard = muiStyled(Stack)(() => ({
  background: NEW_COLORS.BASE.WHITE,
  borderRadius: '8px',
  padding: '24px',
}));

const LinkRedirect = muiStyled(Typography)(() => ({
  minWidth: '60px',
  height: '20px',
  cursor: 'pointer',
  textDecoration: 'underline',
  color: `${NEW_COLORS.PRIMARY[500]}`,
}));

export { StackCard, StackRow, Label, LinkRedirect };
